export enum BreaksMappingDestination {
  Duty50 = 0,
  Duty100 = 1,
  Work = 2,
}
